<template>
  <div class="box box--agenda">
    <div class="box-img-wrapper">
      <template v-if="box.videoURL && thumbnail">
        <img :src="thumbnail">
      </template>
      <AttachmentLoader v-else-if="box.videoURL && !thumbnail"></AttachmentLoader>
      <ImageWrapper :file="box.idFile" :key="box.idFile" v-else></ImageWrapper>
    </div>
    <div class="box-inner">
      <span class="box-tag">
        <span>{{box.targetAudience}}</span>
<!--        <span>Additional Content</span>-->
      </span>
      <router-link :to="{name: 'AgendaSingleMain', params: {id: box.idAgendaEntry }}" class="box-title"><span>{{box.title}}</span></router-link>
      <div class="box-bottom">
        <i class="icon-calendar"></i>
        <span>{{box.startDate | agendaDate(box.endDate, box.hideTime)}}<br>
          {{type.value}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import vimeo from "@/api/external/vimeo";
import AttachmentLoader from "@/components/forms/AttachmentLoader";
import settings from "@/settings";
export default {
  name: "BoxAgenda",
  components: {AttachmentLoader, ImageWrapper},
  props: ['box'],
  data() {
    return {
      thumbnail: ""
    }
  },
  computed: {
    type() {
      return this.$store.getters.settingsCompanyBySettingTypeCodeAndID(settings.SETTING_TYPES.AGENDA_TYPE, this.box.idType)
    }
  },
  mounted() {
    if(this.box.videoURL) {
      this.getVideoThumbnail()
    }
  },
  methods: {
    getVideoThumbnail() {
      let yt_rx = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      let matches = this.box.videoURL.match(yt_rx)
      if(matches) {
        this.setYTThumbnail(matches[5])
      }

      let vm_rx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
      if(this.box.videoURL.match(vm_rx))      {
        this.setVimeoThumbnail()
      }
    },
    setVimeoThumbnail() {
      vimeo.getThumbnail(this.box.videoURL, (response) => {
        this.thumbnail = response.thumbnail_url
      })
    },
    setYTThumbnail(videoId) {
      this.thumbnail = `https://i1.ytimg.com/vi/${videoId}/maxresdefault.jpg`
    }
  }
}
</script>
